import type { ThreadItem } from "./api";

/**
 * The panel's thread finder, behind the rail's "+N" (slice 1 spec §7.1). It works
 * on the loaded Mine threads, newest first.
 */

/** Threads whose title or preview holds every word of `query`, in their order. */
export function findThreads(threads: ThreadItem[], query: string): ThreadItem[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return threads;
  return threads.filter((t) => {
    const text = `${t.title} ${t.preview}`.toLowerCase();
    return words.every((w) => text.includes(w));
  });
}

/** Every loaded thread, across the pages fetched so far. */
export function loadedThreads(data: { pages: Array<{ threads: ThreadItem[] }> } | undefined) {
  return data?.pages.flatMap((p) => p.threads) ?? [];
}

/** What the switcher says in place of rows: nothing to show, or nothing matching. */
export function emptyNote(total: number, shown: number): string | null {
  if (total === 0) return "No threads yet.";
  if (shown === 0) return "No thread matches.";
  return null;
}
